exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".NewAccount__NewAccount__YX8Gv {\n    padding: 1rem;\n    height: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: center;\n        justify-content: center;\n}\n.NewAccount__titleHolder__fcHnv {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-positive: 0;\n        flex-grow: 0;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.NewAccount__titleHolder__fcHnv h2 {\n    margin: 0;\n    width: auto;\n    -ms-flex-positive: 0;\n        flex-grow: 0;\n}\n\n.NewAccount__SignIn__1O3Yn {\n    margin-bottom: 1rem;\n    font-size: 0.8rem;\n}\n\n.NewAccount__AccountLink__PMcq_ {\n    color: #0087ff;\n    cursor: pointer;\n}", ""]);

// exports
exports.locals = {
	"NewAccount": "NewAccount__NewAccount__YX8Gv",
	"titleHolder": "NewAccount__titleHolder__fcHnv",
	"SignIn": "NewAccount__SignIn__1O3Yn",
	"AccountLink": "NewAccount__AccountLink__PMcq_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/User/NewAccount/NewAccount.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/User/NewAccount/NewAccount.css
// module chunks = 0